import React, { useState } from 'react';
import { useRouter } from 'shared-routing';
import { ChildWrapper, DropdownIndicator, ItemButton } from './Button.styles';
import { setItemAction } from './services';

export type ButtonProps = {
  label?: any;
  route?: any;
  action?: (object) => void;
  content?: string | JSX.Element;
  externalLink?: boolean;
};

export const Button: React.FC<ButtonProps> = ({ label, route, action, content, externalLink }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const router = useRouter();

  const pushRoute = () => (externalLink ? window.open(route) : router.push(route));
  const toggleContent = (e) => {
    e.stopPropagation();
    setIsExpanded(!isExpanded);
  };
  const isActiveRoute = router?.asPath === route;

  const itemAction = setItemAction({
    content,
    route,
    action,
    toggleContent,
    pushRoute,
  });

  return (
    <>
      <ItemButton onClick={itemAction} isActiveRoute={isActiveRoute}>
        {label}
        {content ? <DropdownIndicator open={isExpanded} /> : null}
      </ItemButton>
      {content ? <ChildWrapper isVisible={isExpanded}>{content}</ChildWrapper> : null}
    </>
  );
};
